import { Info } from 'lucide-react';
import { Badge, Switch } from '@/contasis';

interface GuidedHelpRowProps {
  enabled: boolean;
  onToggle: (valor: boolean) => void;
  disabled?: boolean;
}

export function GuidedHelpRow({ enabled, onToggle, disabled }: GuidedHelpRowProps) {
  return (
    <div className="mb-5">
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-1.5">
          <p className="text-ui-sm font-semibold text-primary">Ayuda guiada</p>
          <Badge variant={enabled ? 'green' : 'gray'} size="sm" noDot>
            {enabled ? 'Activa' : 'Inactiva'}
          </Badge>
        </div>

        <Switch checked={enabled} onChange={onToggle} disabled={disabled} size="md" />
      </div>

      {/* Se ve igual esté activa o inactiva — describe la función, no su estado. */}
      <p className="mt-1.5 text-caption text-tertiary">
        Te muestra indicaciones en pantalla y te guía paso a paso.
      </p>

      {enabled && (
        <div className="mt-2 inline-flex items-center gap-1.5 rounded-md border border-info-border bg-info-bg py-0.5 pl-1.5 pr-2.5">
          <Info className="h-3 w-3 flex-shrink-0 text-info" />
          <span className="text-label font-semibold text-info">
            Disponible solo en algunos módulos
          </span>
        </div>
      )}
    </div>
  );
}
